// extracted by mini-css-extract-plugin
export default {"zoomControls":"sra-z","zoomControlButton":"tra-z","zoomBanner":"ura-z","bannerButton":"vra-z","imageButton":"wra-z"};